import { useCallback } from 'react';
import isEmpty from 'lodash/isEmpty';
import isNil from 'lodash/isNil';

import {
  UniversalFilterItemTagsValue,
  UniversalFilterItemTagsModes,
  UniversalFilterItemTagsFilterState,
  UniversalFilterItemTagsOnChange
} from '../../UniversalFilterItemTags.types';

interface UniversalFilterItemTagsFilterStateOptions {
  onChange: UniversalFilterItemTagsOnChange;
}

function useUniversalFilterItemTagsFilterState({
  onChange
}: UniversalFilterItemTagsFilterStateOptions) {
  const handleApplyFilterState = useCallback<
    (filterState: UniversalFilterItemTagsFilterState) => void
  >(
    (filterState) => {
      const itemTagIds = filterState?.itemTagIds;

      if (filterState?.mode === UniversalFilterItemTagsModes.CONTAINS_ALL_OF) {
        onChange(isEmpty(itemTagIds) ? undefined : { in: itemTagIds });
        return;
      }

      onChange();
    },
    [onChange]
  );

  const handleParseFilterValue = useCallback<
    (
      filterValue: UniversalFilterItemTagsValue
    ) => UniversalFilterItemTagsFilterState | undefined
  >((filterValue) => {
    if (isNil(filterValue)) {
      return undefined;
    }

    if (!isEmpty(filterValue?.in)) {
      return {
        mode: UniversalFilterItemTagsModes.CONTAINS_ALL_OF,
        userIds: filterValue.in
      };
    }

    return undefined;
  }, []);

  return { handleApplyFilterState, handleParseFilterValue };
}

export default useUniversalFilterItemTagsFilterState;
